import { useEffect } from "react";
import { IHook } from "./homeInstagram.types";

export const useHomeInstagram: IHook = ({ showModal }) => {
  useEffect(() => {
    if (!showModal) {
      return;
    }

    showModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
